<!-- Modal -->
<p class="forgotBtn"><a href="JavaScript:Void(0);" data-toggle="modal" data-target="#forgotPassModal">¿Olvidaste tu contraseña?</a></p>

<div class="modal fade" id="forgotPassModal" tabindex="-1" role="dialog" aria-labelledby="forgotPassModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="forgotPassModalLabel">Recuperar contraseña</h5>
                <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <form [formGroup]="forgotPassForm" (ngSubmit)="sendConfirmationCode()" *ngIf="!confirmationSent">
                <div class="modal-body" >
                    <p>Se le enviará un código de confirmación a su correo electrónico.</p>
                    <div class="form-group">
                        <label for="UserName">Email</label>
                        <input type="text" class="form-control" id="UserName" formControlName="UserName">
                    </div>  
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                    <button type="submit" class="btn btn-primary">Enviar</button>
                </div>
            </form>

            <form [formGroup]="confirmaPassForm" (ngSubmit)="setNewPass()" *ngIf="confirmationSent && !passwordChanged">
                <div class="modal-body" >
                    
                    <div class="form-group">
                        <label for="UserName">Email</label>
                        <input type="text" class="form-control" id="UserName" formControlName="UserName">
                    </div>
    
                    <div class="form-group mt-2">
                        <app-password-check [password]="password" (passActive)="checkPass($event)"></app-password-check>
                    </div> 
    
                    <div class="form-group">
                        <label for="password">Contraseña</label>
                        <input type="password"  class="form-control" id="password" formControlName="NewPwd" (input)="checkPassword()">
                    </div> 

                    <div class="form-group mt-4">
                        <label for="ConfirmationCode">Código de confirmación</label>
                        <input type="text" class="form-control" id="ConfirmationCode" formControlName="ConfirmationCode">
                    </div>
                    
                </div>
                
                <div class="modal-footer">
                    
                    <!-- <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                    <button [disabled]="!validPass" type="submit" class="btn btn-primary">Cambiar</button>
                </div>
    
                
            </form>

            <div class="modal-body">
                <div *ngIf="successMsg" class="alert alert-success" role="alert">
                    {{ successMsg }}
                </div>
    
                <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
                    {{ errorMsg }}
                </div>
            </div>

            
    </div>
    </div>
    </div>